import React, { useState } from "react";
import { ApplicationTileProps } from "./ApplicationTileProps";
import { ReactComponent as Arrow } from "../../resources/images/arrow.svg";
import { ReactComponent as Dots } from "../../resources/images/dots.svg";
import CloseMenuIcon from "../../resources/wrappers/menu/CloseMenuIcon";
import './ApplicationTile.scss'

const ApplicationTile = (props: ApplicationTileProps) => {
    const [open, setOpen] = useState(false);

    const handleOpenMenu = () => {
        setOpen((prevState) => !prevState)
    }

    return (
        <div className="application-tile-wrapper">
            {open ? (
                <div className="application-tile-background" />
            ) : null}
            <div
                className={`application-tile-container ${open ? 'active' : ''}`}
            >
                <div className="application-tile-top">
                    <p className="application-tile-title">{props.name}</p>
                    <div
                        className="category-main-content-button-dots"
                        onClick={() => handleOpenMenu()}
                    >
                        <Dots className="application-info-dots-icon" />
                    </div>
                </div>
                <div className="application-tile-bottom">
                    <div />
                    <Arrow className="application-info-arrow-icon" onClick={props.onClick} />
                </div>
                {open ? (
                    <div className="application-tile-menu">
                        <div className="application-tile-menu-header">
                            <p className="application-tile-menu-title">
                                Cosa vuoi fare?
                            </p>
                            <div onClick={() => handleOpenMenu()}>
                                <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'} />
                            </div>
                        </div>
                        <div className="category-meatball-row" />
                        <p className="application-tile-menu-link-red" onClick={props.removeOnClick}>ELIMINA</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
}


export default ApplicationTile;
